import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import HomePage from '../pages/HomePage';
import NotFoundPage from '../pages/NotFoundPage.jsx';
import ForceLogin from '../components/Demo/ForceLogin.jsx';
import LoginPage from '../pages/LoginPage/index.js';
import Loading from '../pages/Loading.jsx';
import Providers from '../pages/LoginPage/Providers.jsx';
import ChangePassword from '../pages/ChangePassword';
import { PATH_URL } from '../constant';
import '../index.css';
import { Notification } from '@nutanix-ui/prism-reactjs';

const routes = [
    {
        path: '/',
        exact: true,
        render: props => (
            <HomePage {...props}>
                <Loading />
            </HomePage>
        ),
    },
    {
        path: '/callback',
        exact: false,
        render: props => (
            <HomePage {...props}>
                <Loading />
            </HomePage>
        ),
    },
    {
        path: '/login',
        exact: true,
        render: props => <LoginPage {...props} />,
    },
    {
        path: '/forcelogin',
        exact: true,
        render: () => <ForceLogin />,
    },
    {
        path: '/providers',
        exact: true,
        render: props => <Providers {...props} />,
    },
    {
        path: '/pagenotfound',
        exact: true,
        render: props => (
            <HomePage {...props}>
                <NotFoundPage />
            </HomePage>
        ),
    },
    {
        path: '/change-password',
        exact: true,
        render: () => <ChangePassword />,
    },
];

/**
 * Class components Routes
 */
class Routes extends Component {
    // eslint-disable-line react/prefer-stateless-function

    constructor(props) {
        super(props);
    }
    render() {
        const { history } = this.props;
        return (
            <Router history={history} basename={PATH_URL.BASENAME}>
                <div className="Iam">
                    <div className="iam-main">
                        {routes.map((route, index) => (
                            <Route
                                key={index}
                                path={route.path}
                                exact={route.exact}
                                render={route.render}
                            />
                        ))}
                    </div>
                    <Notification>
                        <div
                            style={{
                                position: 'fixed',
                                top: '80px',
                                right: '340px',
                            }}
                        />
                    </Notification>
                </div>
            </Router>
        );
    }
}

Routes.propTypes = {
    history: PropTypes.object,
};

export default Routes;
